import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'wk8-pipe-front',
  imports: [NgClass],
  templateUrl: './wk8-pipe-front.component.html',
  styleUrl: './wk8-pipe-front.component.css',
})
export class Wk8PipeFrontComponent {
  orientation = input<'left' | 'right' | 'up' | 'down'>('left');
  glowing = input(true);
  readonly assetPath = 'assets/woordkr8/sprites/';
}
